// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2sNcC","content":"Consent_content__3-0hb","footer":"Consent_footer__3sc1W"};